import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import { P } from "../engine";
import { StatusBadge } from "./SectionCommon";

// Números de ejes y etiquetas con formato es-AR (1.234,5) en todos los gráficos (hoja 01, fila 102).
Chart.defaults.locale = "es-AR";

// Dibuja un gráfico del catálogo (hoja 25) con la configuración que arma el motor (graficoBuild).
// Sin datos suficientes el motor devuelve { pend: motivo } y se muestra «Pendiente» con el motivo (no se dibuja con
// datos supuestos); { ok: texto } es un estado positivo (p. ej. «Sin brechas abiertas»).
export function Grafico({ f, g, alto = 270, mostrarTitulo = true, t = (k) => k }) {
  const canvas = useRef(null);
  const cfg = f ? P.graficoBuild(f, g) : { pend: "sin datos" };
  const dibujable = !cfg.pend && !cfg.ok;

  useEffect(() => {
    if (!dibujable || !canvas.current) return undefined;
    let chart = null;
    try {
      // el entorno sin canvas (pruebas, algunos navegadores sin aceleración) no rompe la pantalla
      if (canvas.current.getContext && canvas.current.getContext("2d")) chart = new Chart(canvas.current, { ...cfg, options: { ...cfg.options, maintainAspectRatio: false } });
    } catch (e) {
      chart = null;
    }
    return () => { if (chart) chart.destroy(); };
  });

  return (
    <div className="ep-chart" data-grafico={g.id}>
      {mostrarTitulo && <div className="ep-chart__title">{g.titulo} <span className="ep-chart__cl">{g.cl}</span></div>}
      {cfg.pend && <p className="ep-chart__state"><StatusBadge estado="Pendiente">{t("energy_performance_pending")}</StatusBadge> {cfg.pend}.</p>}
      {cfg.ok && <p className="ep-chart__state"><StatusBadge estado="Cumple">{cfg.ok}</StatusBadge></p>}
      {dibujable && (
        <div className="ep-chart__wrap" style={{ height: alto }}>
          <canvas ref={canvas} role="img" aria-label={`${g.titulo}. ${g.nota}`} />
        </div>
      )}
      <p className="ep-chart__note"><strong>{t("energy_performance_chart_shows")}:</strong> {g.nota}</p>
    </div>
  );
}

// Gráfico del catálogo por id, para insertarlo en una pantalla (p. ej. la dispersión en Línea de base).
export function GraficoCatalogo({ f, id, alto, t }) {
  const g = P.GRAFICOS.find((x) => x.id === id);
  return g ? <Grafico f={f} g={g} alto={alto} t={t} /> : null;
}
